import { stringify as wktStringify } from 'wkt';
export class planDataCollector {

   static PlanDataDelområde(geojson: any): Promise<any> {
      return fetchPlanDataWFS("theme_pdk_lokalplandelomraade_vedtaget", geojson);
   }
   static PlanDataLokalPlan(geojson: any): Promise<any> {
      return fetchPlanDataWFS("theme_pdk_lokalplan_vedtaget", geojson);
   }
   static PlanDataKommunePlan(geojson: any): Promise<any> {
      return fetchPlanDataWFS("theme_pdk_kommuneplanramme_vedtaget_v", geojson);
   }
   static PlanDataKommunePlanForslag(geojson: any): Promise<any> {
      return fetchPlanDataWFS("theme_pdk_kommuneplanramme_forslag_v", geojson);
   }
   static PlanDataLokalPlanAflyst(geojson: any): Promise<any> {
      return fetchPlanDataWFS("theme_pdk_lokalplan_aflyst", geojson);
   }
   static PlanDataLokalPlanForslag(geojson: any): Promise<any> {
      return fetchPlanDataWFS("theme_pdk_lokalplan_forslag", geojson);
   }



}

function fetchPlanDataWFS(layer, geom) {
   let wkt = wktStringify(geom.features[0])
   let parameters = {
      service: "wfs",
      request: "getFeature",
      version: "2.0.0",
      outputFormat: "json",
      crs: "EPSG:4326",
      typenames: layer,
      CQL_FILTER: `overlaps(geometri, ${wkt}) or within(geometri, ${wkt})`
   };
   return fetch("https://geoserver.plandata.dk/geoserver/wfs", {
      method: "POST",
      headers: {
         "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: (new URLSearchParams(parameters)).toString()
   }).then(async res => {
      if (!res.ok) {
         await res.text().then(text => {
            console.error("Error response from Mat2:", text);
         });
         throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json() as Promise<any>;
   });
}